import { Grid, makeStyles, Typography } from "@material-ui/core";
import FormHandling from "../FormComponent/FormHandling";
import MuiCheckBox from "../FormComponent/MuiCheckBox";
import MuiRadioGroup from "../FormComponent/MuiRadioGroup";
import MuiSelectOption from "../FormComponent/MuiSelectOption";
import MuiTextField from "../FormComponent/MuiTextField";
import { Box, Button } from "@mui/material";
import Title from "./Title";

const useStyle = makeStyles((theme) => ({
  root: {
    "&": {
      margin: theme.spacing(1),
    },
  },
  btnmargin: {
    marginRight: "10px !important",
  },
  gridPadding: {
    padding: "15px",
  },
}));

const StudentResister = () => {
  const classes = useStyle();

  const initialValue = {
    fullName: "",
    email: "",
    gender: "male",
    department: "",
    agree: false,
  };

  const RadioItem = [
    { id: 0, value: "male", label: "Male" },
    { id: 1, value: "female", label: "Female" },
    { id: 2, value: "other", label: "Other" },
  ];

  const DepartmentOptions = [
    { id: 0, value: "Web Developer", title: "Web Developer" },
    { id: 1, value: "Graphic Designer", title: "Graphic Designer" },
    { id: 2, value: "Amazon Affiliate", title: "Amazon Affiliate" },
    { id: 3, value: "SEO Expart", title: "SEO Expart" },
  ];

  const { studentData, handleChange, setStudentData } =
    FormHandling(initialValue);

  const { fullName, gender, email, department, agree } = studentData;

  const btnClear = () => {
    setStudentData(initialValue);
  };

  const btnSubmit = () => {
    console.log("studentData===>", studentData);
  };

  return (
    <form autoComplete="off">
      <Grid className={classes.gridPadding}>
        <Grid item container xs={12}>
          <Title>Register Student</Title>
        </Grid>
        <Grid item container spacing={2}>
          <Grid item xs={6} className={classes.root}>
            <MuiTextField
              fullWidth
              label="Full Name"
              name="fullName"
              value={fullName}
              onChange={handleChange}
            />
            <Box sx={{ p: "10px" }} />
            <MuiTextField
              fullWidth
              label="Email Address"
              name="email"
              value={email}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={6} className={classes.root}>
            <MuiRadioGroup
              row
              label="Gender"
              name="gender"
              value={gender}
              onChange={handleChange}
              RadioItem={RadioItem}
            />
            <Box sx={{ p: "5px" }} />
            <MuiSelectOption
              label="Choose Department"
              name="department"
              value={department}
              onChange={handleChange}
              DepartmentOptions={DepartmentOptions}
            />
            <Box sx={{ p: "10px" }} />

            <MuiCheckBox
              name="agree"
              value={agree}
              label="Agree with Terms & Conditons"
              onChange={handleChange}
            />
          </Grid>
        </Grid>
        <Box sx={{ p: "10px" }} />

        <Grid item container p={2}>
          <Button
            variant="contained"
            className={classes.btnmargin}
            onClick={btnClear}
          >
            Clear
          </Button>
          <Button variant="contained" color="success" onClick={btnSubmit}>
            Submit
          </Button>
        </Grid>
      </Grid>
    </form>
  );
};

export default StudentResister;
